<template>
	<div
		v-show="isActive"
		class="tabs__content checkout-item__tabs-content"
		:class="{ 'tabs__content--active': isActive }"
	>
		<slot :is-active="isActive" />
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			required: true
		},
		activeTab: {
			type: String,
			default: ''
		}
	},

	computed: {
		isActive() {
			return this.value === this.activeTab;
		}
	},

	watch: {
		isActive(newVal) {
			if (newVal) {
				this.$emit('shown');
			} else {
				this.$emit('hidden');
			}
		}
	}
};
</script>
